export default __webpack_public_path__ + "static/hepato-kak-da-namalim-riska-header-23f18488f2cd06251fc8a15f74bbea2c.jpg";